module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("I would like to dedicate "), _c('em', [_vm._v("The Mastery of Life")]), _vm._v(" to my daughter, Anna, for her unreserved support and understanding during the time I have worked on this book. I would also like to thank my dad for his support and for his wisdom, which he has shared with me relentlessly over the years. Lastly, I would like to thank my sister, Tania, for her guidance regarding some aspects of this book and the same applies to my good friends: Andrew and Richard. I would like to thank you all for all your support, love and understanding—it’s all very much appreciated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0